module.exports = __webpack_public_path__ + "static/media/lisa.29a969e8.jpg";